module.exports = __webpack_public_path__ + "static/media/red_bag.86ffe17f.gif";